/* eslint-disable */
import React from 'react';
import { default as Domain } from '@icimscorp/mui-acs/build/components/CampaignsList';
import { userActions } from 'redux/actions';
import { sendMsgToExt } from 'util/messagePassing';
import { useSelector, useDispatch } from 'react-redux';
import { outbound } from 'extActions';
import { track } from 'util/pendo';
import { pendoTypes } from 'appConstants';
import PropTypes from 'prop-types';

const BlacklistedDomain = ({ urlOrigin }) => {
	const dispatch = useDispatch();
	const { blacklistedDomains } = useSelector((state) => state.user.preferences);
	const { internalCustomerType } = useSelector((state) => state.user.customer);

	const handleReIncludeDomain = () => {
		const updatedBlacklistDomains = blacklistedDomains.filter((domain) => domain !== urlOrigin);
		dispatch(userActions.updateBlacklist({ updatedBlacklistDomains }));
		sendMsgToExt({
			action: outbound.INCLUDE_DOMAIN,
			additionalData: { urlOrigin }
		});

		track(
			pendoTypes.reincludeBlacklistedWebsite,
			{
				reincludedWebsite: urlOrigin
			},
			internalCustomerType
		);
	};

	return (
		<Domain
			data-testid="blacklistedDomain"
			textLabel={<div style={{ padding: '12px' }}>{urlOrigin}</div>}
			buttonLabel={'Reinclude'}
			isThisANewCampaign
			handleButtonClick={handleReIncludeDomain}
		/>
	);
};

BlacklistedDomain.propTypes = {
	urlOrigin: PropTypes.string.isRequired
};

export default BlacklistedDomain;
